// @flow

import React from 'react';
import type { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { compose } from 'redux';
import styled, { css } from 'styled-components';
import {
  AssortmentContainer,
  AssortmentStoreProvider,
  FacetsColumn,
  ActiveFiltersButtonContainer,
  ActiveFiltersContainer,
  RemoveFiltersButtonContainer,
  FilterBarContainer,
  ResultCount,
  FiltersColumn,
  FilterDrawer,
  FACETS_COLUMN_NAME,
} from '@leasen_nl/listo/src/components/assortment';
import type { ACFPage } from '@leasen_nl/listo/src/types';
import Rows from '@leasen_nl/listo/src/components/rows';
import { Container, Flex, Box } from '@leasen_nl/listo/src/components/grid';
import { breakpointsToArray, media } from '@leasen_nl/listo/src/helpers';
import { setUiSetting } from '@leasen_nl/listo/src/store/uiStore';
import type { Theme } from '@types/index';

type DispatchProps = {|
  handleOpenDrawer: Function,
|};

type Props = {|
  ...DispatchProps,
  acf: ACFPage,
|};

const StyledContainer = styled<typeof Container, Theme, _>(Container)`
  padding: 2rem 0 0 0;
  ${media.md(css`
    padding: 4rem 0 0 0;
  `)}
`;

const Icon = styled<any, Theme>('i')`
  font-size: 1.5rem;
  line-height: 1.5rem;
  padding-right: .5rem;
  &:before {
    vertical-align: middle;
  }
`;

const AssortmentPage = ({ handleOpenDrawer, acf: { rows } }: Props) => (
  <>
    <Rows rows={rows} />
    <StyledContainer>
      <AssortmentStoreProvider>
        <Flex width={1} wrap>
          <Flex width={3 / 12} flexDirection="column">
            <FilterDrawer>
              <ResultCount />
              <FacetsColumn />
              <FiltersColumn />
            </FilterDrawer>
          </Flex>
          <Box
            width={breakpointsToArray({
              default: 12 / 12,
              lg: 9 / 12,
            })}
          >
            <Box px="1rem">
              <Flex justifyContent="space-between" pb="0.5rem">
                <ActiveFiltersButtonContainer
                  onClick={handleOpenDrawer}
                  icon={<Icon className="icon-flexibility" />}
                />
                <RemoveFiltersButtonContainer />
              </Flex>
              <FilterBarContainer />
              <ActiveFiltersContainer />
            </Box>
            <AssortmentContainer />
          </Box>
        </Flex>
      </AssortmentStoreProvider>
    </StyledContainer>
  </>
);

const mapDispatchToProps = (dispatch: Dispatch<*>): DispatchProps => ({
  handleOpenDrawer: () => dispatch(setUiSetting(FACETS_COLUMN_NAME, true)),
});

export default compose(
  connect<Props, any, any, DispatchProps, any, any>(
    null,
    mapDispatchToProps,
  ),
)(AssortmentPage);
